// Vendor Libs
import {cloneDeep, set} from 'lodash';

const initialState = {
    fetching: false,
    fetched: false,
    error: null,
    query: {
        page: 1,
        pageLimit: 20,
        sort: [],
    },
    queryUpdated: false,
    searchData: {
        content: [],
        first: true,
        last: true,
        number: 0,
        numberOfElements: 0,
        size: 10,
        sort: null,
        totalElements: 0,
        totalPages: 1,
    },
    filter: {
        actionId: null,
        targets: [],
    },
};

function getInitialState() {
  return cloneDeep(initialState);
}

const customInitialState = {
    audits: set(getInitialState(), 'query.sort', [
        {
            column: 'lastUpdated',
            order: 'desc',
        },
    ]),
    displayPaths: set(getInitialState(), 'query.sort', [
        {
            column: 'network.name',
            order: 'asc',
        },
        {
            column: 'displayPath',
            order: 'asc',
        },
    ]),
    displayPathModifiers: set(getInitialState(), 'query.sort', [
        {
            column: 'priority',
            order: 'asc',
        },
    ]),
    flaggedMetadata: set(getInitialState(), 'query.sort', [
        {
            column: 'amsPrograms.title',
            order: 'asc',
        },
    ]),
    networks: set(getInitialState(), 'query.sort', [
        {
            column: 'name',
            order: 'asc',
        },
    ]),
    massActionResults: set(getInitialState(), 'query.sort', [
        {
            column: 'lastUpdated',
            order: 'desc',
        },
    ]),
    moviesAndProgramsMappingEpisodes: set(getInitialState(), 'query.sort', [
        {
            column: 'originalAirDate',
            order: 'desc',
        },
    ]),
    networksMapping: set(set(getInitialState(), 'query.pageLimit', 2500), 'query.sort', [
        {column: 'name', order: 'asc'},
    ]),
    networksSelect: set(set(getInitialState(), 'query.pageLimit', 2500), 'query.sort', [
        {column: 'name', order: 'asc'},
    ]),
    providers: set(getInitialState(), 'query.sort', [
        {
            column: 'name',
            order: 'asc',
        },
    ]),
    providersSelect: set(set(getInitialState(), 'query.pageLimit', 2500), 'query.sort', [
        {column: 'name', order: 'asc'},
    ]),
    rolesTree: set(getInitialState(), 'query.pageLimit', 100),
    scopesTree: set(getInitialState(), 'query.pageLimit', 100),
    unmappedMediaItems: set(getInitialState(), 'query.sort', [
        {
            column: 'sortablePriority',
            order: 'asc',
        },
        {
            column: 'offerings.startDate',
            order: 'asc',
        },
    ]),
    users: set(getInitialState(), 'query.sort', [
        {
            column: 'clientId',
            order: 'asc',
        },
    ]),
    violations: set(getInitialState(), 'query.sort', [
        {
            column: 'lastUpdated',
            order: 'desc',
        },
    ]),
};

export default function getServiceInitialState(servicesDataKey) {
    return cloneDeep(customInitialState[servicesDataKey] || getInitialState());
}
